module.exports = __webpack_public_path__ + "img/marker_red.dc7e29e8.png";